import {searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'foto/pdf';
const CONTEXT_SINGLE_BASE_PATH = 'foto/pdfindividual';
// #endregion

// #region Public functions
async function getPhotoPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchPhotosPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getPhotoPdf,
  searchPhotosPdf,
};
